/**
 * All user-visible static text for BottlerElmAccess component
 * and BottlerElmAccessContext toast messages.
 */

// ── Navigation ─────────────────────────────────────────────────────────────
export const BOTTLER_ELM_BREADCRUMB  = ["User Access Management", "Bottler Onboarding"];
export const BTN_INVITE_USERS        = "+ Invite Users";
export const APPLICATION_FILTER_LABEL = "Application";
export const SOP_APPLICATION_NAME = "S&OP - Sales And Operations Planning";
export const BOTTLER_ONBOARDING_APPLICATIONS = [
  SOP_APPLICATION_NAME,
];
export const TAB_INVITE_USER = "Invite Bottler";
export const TAB_INVITED_USERS = "Manage Bottler";
export const SELECT_APPLICATION_TITLE = "Select an application to continue";
export const SELECT_APPLICATION_MESSAGE = "Choose an application above to invite bottler or manage existing invitations.";

// ── Page header ───────────────────────────────────────────────────────────
export const PAGE_TITLE   = "Bottler Onboarding - Manage Users";
export const PAGE_RIBBON  = "View and manage users for the selected application. You can invite new users, edit their access, or delete existing users.";

// ── Application constant shared across invite / edit payloads ──────────────

// ── Context toast messages ─────────────────────────────────────────────────
export const TOAST_FETCH_USER_LIST_ERROR = "Failed to fetch onboarded user list.";
export const TOAST_INVITE_SUCCESS        = "Users invited successfully.";
export const TOAST_INVITE_ERROR          = "Failed to invite users.";
export const TOAST_DELETE_SUCCESS        = "User access removed.";
export const TOAST_DELETE_ERROR          = "Failed to remove user.";
export const TOAST_UPDATE_SUCCESS        = "User updated successfully.";
export const TOAST_UPDATE_ERROR          = "Failed to update user.";
export const TOAST_FETCH_DOMAIN_ERROR    = "Failed to fetch domain list.";
